import React from "react";
import { useDispatch } from "react-redux";

import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

import {
  showDangerAlert,
  showSuccessAlert,
} from "../../../../redux/actions/alert/alertActions";

import ButtonComponent from "../../button";
import InputComponent from "../../form/input";

const NewCommentComponent = ({
  simID,
  newCommentUseState: [newComment, setNewComment],
  postCommentFunction,
  postCommentError,
}) => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({ mode: "onChange" });

  const onSubmit = () => {
    postCommentFunction({ ...newComment, sim: simID })
      .then(() => {
        setNewComment({ title: "", content: "" });
        dispatch(
          showSuccessAlert(
            "نظر شما با موفقیت ثبت شد و این نظر در لیست انتظار قرار گرفته شد."
          )
        );
      })
      .catch(() => {
        dispatch(showDangerAlert(postCommentError));
      });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InputComponent
        type="text"
        title="عنوان نظر"
        register={register("title", {
          required: true,
          onChange: (e) => setNewComment({ ...newComment, title: e.target.value }),
        })}
        containerClass="mb-3"
        maxLength={process.env.REACT_APP_USER_COMMENT_TITLE_MAX_LENGTH}
        className="comment-input w-100 bg-transparent"
      />
      <InputComponent
        as="textarea"
        title="متن نظر شما"
        value={newComment.content}
        register={register("comment", {
          required: true,
          onChange: (e) => setNewComment({ ...newComment, content: e.target.value }),
        })}
        containerClass="mb-3"
        maxLength={process.env.REACT_APP_USER_COMMENT_CONTENT_MAX_LENGTH}
        className="comment-input w-100 bg-transparent"
      />
      <ButtonComponent
        type="submit"
        className="comment-submit d-block mx-auto"
        disabled={!isValid}
      >
        ثبت نظر
      </ButtonComponent>
    </Form>
  );
};

export default NewCommentComponent;
